import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ClientsPage from "@/pages/ClientsPage";
import ClientFormPage from "@/pages/ClientFormPage";
import OffersPage from "@/pages/OffersPage";
import OfferWizardPage from "@/pages/OfferWizardPage";
import OfferDetailPage from "@/pages/OfferDetailPage";
import CatalogPage from "@/pages/CatalogPage";
import PackagesPage from "@/pages/PackagesPage";
import AtecoPage from "@/pages/AtecoPage";
import UsersPage from "@/pages/UsersPage";
import SettingsPage from "@/pages/SettingsPage";
import ReportsPage from "@/pages/ReportsPage";
import FollowUpsPage from "@/pages/FollowUpsPage";
import PublicOfferPage from "@/pages/PublicOfferPage";
import { Toaster } from "sonner";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/p/offerta/:token" element={<PublicOfferPage />} />

          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/offerte" element={<OffersPage />} />
            <Route path="/offerte/nuova" element={<OfferWizardPage />} />
            <Route path="/offerte/:id/modifica" element={<OfferWizardPage />} />
            <Route path="/offerte/:id" element={<OfferDetailPage />} />
            <Route path="/clienti" element={<ClientsPage />} />
            <Route path="/clienti/nuovo" element={<ClientFormPage />} />
            <Route path="/clienti/:id" element={<ClientFormPage />} />
            <Route path="/listino" element={
              <ProtectedRoute roles={["admin", "direzione"]}><CatalogPage /></ProtectedRoute>
            } />
            <Route path="/pacchetti" element={
              <ProtectedRoute roles={["admin", "direzione"]}><PackagesPage /></ProtectedRoute>
            } />
            <Route path="/ateco" element={
              <ProtectedRoute roles={["admin", "direzione"]}><AtecoPage /></ProtectedRoute>
            } />
            <Route path="/report" element={
              <ProtectedRoute roles={["admin", "direzione"]}><ReportsPage /></ProtectedRoute>
            } />
            <Route path="/followups" element={<FollowUpsPage />} />
            <Route path="/utenti" element={
              <ProtectedRoute roles={["admin"]}><UsersPage /></ProtectedRoute>
            } />
            <Route path="/impostazioni" element={
              <ProtectedRoute roles={["admin"]}><SettingsPage /></ProtectedRoute>
            } />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
